const MENU_CACHE_LIMIT = 5;

export { MENU_CACHE_LIMIT };
